import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductItemComponent } from '../product-item/product-item.component';
import { trigger, style, transition, animate, group, query, sequence } from '@angular/animations';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { AlpitranslatePipe } from '../../../../core/pipes/alpitranslate.pipe';
import { Cart, Product } from '../../services/entities';

@Component({
  selector: 'app-product-list',
  imports: [AlpitranslatePipe, ProductItemComponent, SkeletonLoaderComponent],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('blend', [
      transition(':increment, :decrement', [
        group([
          query(
            ':leave',
            [
              sequence([
                style({ opacity: 1 }),
                animate('0.1s ease-in-out', style({ opacity: 0 })),
                style({ opacity: 0, display: 'none' })
              ])
            ],
            { optional: true }
          ),
          query(
            ':enter',
            [
              sequence([
                style({ display: 'block', position: 'absolute', opacity: 0 }),
                animate('0.1s 0.11s ease-in-out', style({ position: 'relative' })),
                animate('0.1s 0.11s ease-in-out', style({ opacity: 1, display: 'block' })),
                style({ opacity: 1 })
              ])
            ],
            { optional: true }
          )
        ])
      ])
    ])
  ]
})
export class ProductListComponent implements OnChanges {
  @Input({ required: true }) products: Product[];
  @Input({ required: true }) companyId: number;
  @Input({ required: true }) cart: Cart;
  animation = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['products']) {
      this.animation++;
    }
  }

  isSelected(productId: number): boolean {
    return this.cart.selectedPerson?.productEntities.some(p => p.definitionId === productId);
  }
}
